import React from "react";
import { useStore } from "@/store/StoreContext";
import { imgSrc } from "@/lib/api";

const LAYOUT = ["row-span-2", "", "", "row-span-2", "", ""];

export default function Gallery() {
  const { content } = useStore();
  const tiles = [1, 2, 3, 4, 5, 6]
    .map((n) => content?.[`gallery_${n}`])
    .filter(Boolean)
    .map((src, i) => ({ src, cls: LAYOUT[i] || "" }));
  if (!tiles.length) return null;

  return (
    <section data-testid="festive-gallery" className="relative mx-auto max-w-7xl px-5 py-12 sm:px-8 lg:py-16">
      <div className="reveal mb-9 text-center">
        <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.34em] text-[#8F6E1D]">{content?.gallery_eyebrow || "Festive Inspiration"}</p>
        <h2 className="font-display text-3xl font-semibold tracking-tight text-[#2B1E12] sm:text-4xl lg:text-5xl">
          {content?.gallery_title || "Gifting That Carries a"} <span className="text-gold-gradient italic">{content?.gallery_accent || "Blessing"}</span>
        </h2>
        <p className="font-display mx-auto mt-4 max-w-xl text-lg italic text-[#6B5B45]">
          {content?.gallery_subtext || "Rudraksha styled with diyas, flowers and tradition — meaningful gifts for the ones you love."}
        </p>
      </div>
      <div className="grid auto-rows-[180px] grid-cols-2 gap-4 sm:auto-rows-[220px] lg:grid-cols-4">
        {tiles.map((t, i) => (
          <figure
            key={i}
            data-testid={`gallery-tile-${i}`}
            className={`reveal group relative overflow-hidden rounded-md border border-[#E9DFC8] bg-white ${t.cls}`}
            style={{ transitionDelay: `${i * 80}ms` }}
          >
            <img
              src={imgSrc(t.src)}
              alt={`Festive inspiration ${i + 1}`}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
            />
          </figure>
        ))}
      </div>
    </section>
  );
}
